import { Component, inject } from '@angular/core';
import {Observable, Subject} from "rxjs";
import {
    GeneralTaskUpdateResult,
    ProblemInstanceService,
    SkillLevelService,
    TaskUpdateService,
    TaskView
} from "planner-shared";
import {GeneralTaskDataUpdate} from "../../../../../shared/models/general-task-data-update.model";
import {NotificationService} from "@shared";
import {GeneralTaskDataUpdateResult} from "../../../../../shared/models/general-task-data-update-result.model";

@Component({
    selector: 'app-competence-update-modal',
    templateUrl: './competence-update-modal.component.html',
    styleUrls: ['./competence-update-modal.component.scss'],
    standalone: false
})
export class CompetenceUpdateModalComponent {
    private readonly skillLevelService = inject(SkillLevelService);
    private readonly taskUpdateService = inject(TaskUpdateService);
    private readonly notificationService = inject(NotificationService);
    private readonly problemInstanceService = inject(ProblemInstanceService);


    public set parameter(
        param: { unassignedTask: TaskView, selectedSkillId: number }
    ) {
        this.unassignedTask = param.unassignedTask;
        this.newCompetenceId = param.selectedSkillId;
        this.originalSkillLevelDescription = this.skillLevelService.getSkillLevelDescription(param.unassignedTask.skillRequirement);
        this.newSkillLevelDescription = this.skillLevelService.getSkillLevelDescription(param.selectedSkillId);
    }

    public unassignedTask: TaskView;
    public originalSkillLevelDescription: Observable<string>;
    public newSkillLevelDescription: Observable<string>;
    public isLoading: boolean;
    private newCompetenceId: number;
    private readonly cancel$: Subject<void>;
    private readonly confirm$: Subject<GeneralTaskUpdateResult>;

    constructor() {
        this.cancel$ = new Subject<void>();
        this.confirm$ = new Subject<GeneralTaskUpdateResult>();
        this.isLoading = false;
    }

    public dismissModal(): void {
        this.cancel$.next();
    }

    private confirmModal(): void {
        this.confirm$.next(null);
    }

    public updateOneClicked(): void {
        this.isLoading = true;

        const generalTaskDataUpdateOne: GeneralTaskDataUpdate =
            {
                generalTaskData: [{
                    taskId: this.unassignedTask.taskId,
                    skillRequirement: this.newCompetenceId,
                    appliedForNumber: 1
                }]
            };

        this.taskUpdateService.updateGeneralTaskData(generalTaskDataUpdateOne)
            .subscribe(generalTaskUpdateResult => {
                this.taskUpdateAftermath(generalTaskUpdateResult);
            });
    }

    public updateAllClicked(): void {
        this.isLoading = true;

        const generalTaskDataUpdateAll: GeneralTaskDataUpdate =
            {
                generalTaskData: [{
                    taskId: this.unassignedTask.taskId,
                    skillRequirement: this.newCompetenceId,
                    appliedForNumber: this.unassignedTask.numberOfEmployees
                }]
            };

        this.taskUpdateService.updateGeneralTaskData(generalTaskDataUpdateAll)
            .subscribe(generalTaskUpdateResult => {
                this.taskUpdateAftermath(generalTaskUpdateResult);
            });
    }

    private taskUpdateAftermath(generalTaskUpdateResult: GeneralTaskDataUpdateResult) {
        this.notificationService.success('TASK_UPDATED', null, {id: this.unassignedTask.serviceName});
        this.unassignedTask.editing = false;
        this.problemInstanceService.getProblemInstance().subscribe(instanceResult => {
            instanceResult.problemInstance.geTasksNotPatients = generalTaskUpdateResult.geTasksNotPatients;
            this.problemInstanceService.requestProblemInstance().subscribe(requestInstance => {
                const localTaskWorkShiftCompatibility = new Set(instanceResult.problemInstance.taskWorkShiftCompatibility.map(obj => obj.routePlannerTaskId));
                const updatedTasks = requestInstance.problemInstance.taskWorkShiftCompatibility.filter(obj => !localTaskWorkShiftCompatibility.has(obj.routePlannerTaskId));
                updatedTasks.forEach(updatedTask => instanceResult.problemInstance.taskWorkShiftCompatibility.push(updatedTask));
            });
        });
        this.confirmModal();
    }
}
